import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';
import AnnouncementBar from './components/AnnouncementBar';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustedBySection from './components/TrustedBySection';
import WhatIsSection from './components/WhatIsSection';
import WhyVergeSection from './components/WhyVergeSection';
import CustomerResultsSection from './components/CustomerResultsSection';
import WhitePaperSection from './components/WhitePaperSection';
import IndustriesSection from './components/IndustriesSection';
import TechPartnersSection from './components/TechPartnersSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'VergeIO',
    url: SITE_URL,
    description: 'VergeOS, sanallaştırma, depolama ve ağı tek platformda birleştiren özel bulut işletim sistemidir. VMware maliyetlerini %65 azaltın.',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'VergeIO',
    url: SITE_URL,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'VergeOS',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Any',
    description: 'VergeOS, sanallaştırma, depolama ve ağı tek platformda birleştiren özel bulut işletim sistemidir.',
    url: SITE_URL,
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen w-full">
      <SEOHead
        title="VergeOS | VMware Alternatifi Özel Bulut İşletim Sistemi"
        description="VergeOS, sanallaştırma, depolama ve ağı tek platformda birleştiren özel bulut işletim sistemidir. VMware maliyetlerini %65 azaltın, mevcut donanımınızı kullanın."
        keywords="VergeOS, VMware alternatifi, özel bulut işletim sistemi, sanallaştırma, HCI, ultraconverged"
        canonicalPath="/"
        jsonLd={homeJsonLd}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        <HeroSection />
        <TrustedBySection />
        <WhatIsSection />
        <WhyVergeSection />
        <CustomerResultsSection />
        <WhitePaperSection />
        <IndustriesSection />
        <TechPartnersSection />
        <CTASection />
      </main>
      <FooterSection />
    </div>
  );
}
